import { useQuery } from '@tanstack/react-query';
import { getApiV1Scenarios } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchScenarios = () => {
  const token = useAccessToken();

  return useQuery({
    queryKey: queryKeys.scenarios(),
    queryFn: async () => {
      const response = await getApiV1Scenarios();
      return response.data?.data || [];
    },
    enabled: !!token,
  });
};
